import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  //dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import {
  FileExcelOutlined,
  FilePdfOutlined
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import reporteTraspasoEntreAlmacenesPdf from "../../../../Pdf/reporteTraspasoEntreAlmacenesPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteTraspasoEntreAlmacenes extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoProveedores: null,
    todasProveedores: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    dataReporte: null,
    todasTraspasos: [],
    dataGrafico: [],
    totalInsumosTraspasados: 0,
    desglosarProductos: false,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsuarios: res.data });
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });

    this.consultarReporteTraspasoEntreAlmacenes({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: [],
      usuarios: [],
      proyectos: [],
      estadoTraspaso: 5,
    });
  }

  async crearGrafico(valueTraspasos, fechaInicial, fechaFinal) {
    let grafico = [];
    let graficoSumatoria = [];
    let sumatoria = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    const diffDays = fechaFinalMoment.diff(fechaCambiante, "days");

    if (diffDays <= 31) {
      while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
        const fechaActualIteracion = moment(fechaCambiante);

        const traspasos = valueTraspasos.filter((tras) => {
          return fechaActualIteracion.isSame(
            moment(tras.fecha, "DD/MM/YYYY"),
            "date"
          );
        });

        let totalCantidad = 0;
        traspasos.map((tras) => {
          totalCantidad += tras.cantidadTraspasada;
          return null;
        });

        grafico.push({
          x: fechaActualIteracion.locale("es").format("DD/MM/YYYY"),
          y: totalCantidad,
        });
        graficoSumatoria.push({
          x: fechaActualIteracion.locale("es").format("DD/MM/YYYY"),
          y: totalCantidad + sumatoria,
        });

        sumatoria += totalCantidad;
        fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
      }
    } else if (diffDays < 180) {
      while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
        const fechaActualIteracion = moment(fechaCambiante);

        const traspasos = valueTraspasos.filter((trasp) => {
          return fechaActualIteracion.isSame(
            moment(trasp.fecha, "DD/MM/YYYY"),
            "week"
          );
        });

        let totalCantidad = 0;
        traspasos.map((trasp) => {
          totalCantidad += trasp.cantidadTraspasada;
          return null;
        });

        grafico.push({
          x: fechaActualIteracion.locale("es").format("[SEM] WW/YY"),
          y: totalCantidad,
        });
        graficoSumatoria.push({
          x: fechaActualIteracion.locale("es").format("[SEM] WW/YY"),
          y: totalCantidad + sumatoria,
        });

        sumatoria += totalCantidad;
        fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
      }
    } else {
      while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
        const fechaActualIteracion = moment(fechaCambiante);

        const traspasos = valueTraspasos.filter((trasp) => {
          return fechaActualIteracion.isSame(
            moment(trasp.fecha, "DD/MM/YYYY"),
            "month"
          );
        });

        let totalCantidad = 0;
        traspasos.map((trasp) => {
          totalCantidad += trasp.cantidadTraspasada;
          return null;
        });

        grafico.push({
          x: fechaActualIteracion.locale("es").format("MM-YY"),
          y: totalCantidad,
        });
        graficoSumatoria.push({
          x: fechaActualIteracion.locale("es").format("MM-YY"),
          y: totalCantidad + sumatoria,
        });

        sumatoria += totalCantidad;
        fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
      }
    }

    await this.setState({
      dataGrafico: [
        {
          id: "Cantidad Traspasada",
          color: "hsl(15, 70%, 50%)",
          data: grafico,
        },
        {
          id: "Cantidad Acumulada",
          color: "hsl(15, 70%, 50%)",
          data: graficoSumatoria,
        },
      ],
    });
  }

  consultarReporteTraspasoEntreAlmacenes(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeCompras/reporteTraspasoEntreAlmacenes",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (!res.data.desglosarProductos) {
            this.crearGrafico(
              res.data.traspasos,
              res.data.fechaInicial,
              res.data.fechaFinal
            );
          } else {
            this.setState({ dataGrafico: [] });
          }
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasTraspasos: res.data.traspasos,
            totalInsumosTraspasados: res.data.totalInsumosTraspasados,
            desglosarProductos: res.data.desglosarProductos,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        message.error("Error de conexión: " + err.message);
        this.setState({ loading: false });
      });
  }
  descargarExcel() {
    const getEstadoTexto = (estadoNum) => {
      switch (estadoNum) {
        case 1:
          return "Vigente";
        case 0:
          return "Cancelada";
        default:
          return "Desconocido";
      }
    };

    let datosDescargar = [];

    if (this.state.desglosarProductos) {
      // Si se desglosa, mapeamos la lista plana
      let traspasoPadre = {}; // Guardamos la última cabecera
      for (const traspaso of this.state.todasTraspasos) {
        if (traspaso.folio !== "") {
          traspasoPadre = traspaso;
        } else {
          datosDescargar.push({
            Folio: traspasoPadre.folio,
            Fecha: traspasoPadre.fecha,
            Usuario: traspasoPadre.usuario,
            ProyectoOrigen: traspasoPadre.proyectoOrigen,
            ProyectoDestino: traspasoPadre.proyectoDestino,
            "Código Insumo": traspaso.codigo,
            "Clave Insumo": traspaso.clave,
            Descripción: traspaso.descripcion,
            Familia: traspaso.familia,
            Marca: traspaso.marca,
            "Cant. Traspasada": traspaso.cantidadTraspasada,
            "Estado Insumo": getEstadoTexto(traspaso.estado),
            Observaciones: traspaso.observaciones,
          });
        }
      }
    } else {
      datosDescargar = this.state.todasTraspasos.map((traspaso) => {
        return {
          Folio: traspaso.folio,
          Fecha: traspaso.fecha,
          Usuario: traspaso.usuario,
          ProyectoOrigen: traspaso.proyectoOrigen,
          ProyectoDestino: traspaso.proyectoDestino,
          Estado: getEstadoTexto(traspaso.estado),
          "Cant. Traspasada": traspaso.cantidadTraspasada,
          Observaciones: traspaso.observaciones,
        };
      });
    }

    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Traspaso Almacenes");
    XLSX.writeFile(workbook, "Reporte_Traspaso_Almacenes.xlsx");
  }
  descargarPdf() {

    pdfMake
      .createPdf(reporteTraspasoEntreAlmacenesPdf(this.state.dataReporte))
      .download("Reporte_Traspaso_Entre_Almacenes.pdf");
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => a.folio.localeCompare(b.folio),
        buscar: "folio",
        ellipsis: true,
        render: (text, record) => {
          if (!record.esInsumo) {
            return text;
          }
          return ""; // Vacío para filas de insumo
        },
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        sorter: (a, b) =>
          moment(a.fecha, "DD/MM/YYYY").unix() -
          moment(b.fecha, "DD/MM/YYYY").unix(),
        buscar: "fecha",
        ellipsis: true,
        render: (text, record) => (!record.esInsumo ? text : ""),
      },
      {
        title: "Usuario",
        dataIndex: "usuario",
        key: "usuario",
        sorter: (a, b) => a.usuario.localeCompare(b.usuario),
        buscar: "usuario",
        ellipsis: true,
        render: (text, record) => (!record.esInsumo ? text : ""),
      },
      {
        title: "Proyecto Origen",
        dataIndex: "proyectoOrigen",
        key: "proyectoOrigen",
        sorter: (a, b) => a.proyectoOrigen.localeCompare(b.proyectoOrigen),
        buscar: "proyectoOrigen",
        ellipsis: true,
        render: (text, record) => (!record.esInsumo ? text : ""),
      },
      {
        title: "Proyecto Destino",
        dataIndex: "proyectoDestino",
        key: "proyectoDestino",
        sorter: (a, b) => a.proyectoDestino.localeCompare(b.proyectoDestino),
        buscar: "proyectoDestino",
        ellipsis: true,
        render: (text, record) => (!record.esInsumo ? text : ""),
      },
      {
        title: "Clave Insumo",
        dataIndex: "clave",
        key: "clave",
        ellipsis: true,
        render: (text, record) =>
          record.esInsumo ? text : this.state.desglosarProductos ? "" : "N/A",
      },
      {
        title: "Descripción Insumo",
        dataIndex: "descripcion",
        key: "descripcion",
        ellipsis: true,
        render: (text, record) => {
          if (record.esInsumo) {
            return text;
          }

          return this.state.desglosarProductos ? <i>{text}</i> : "N/A";
        },
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        ellipsis: true,
        render: (text, record) => (record.esInsumo ? text : ""),
      },
      {
        title: "Cant. Traspasada",
        dataIndex: "cantidadTraspasada",
        key: "cantidadTraspasada",
        sorter: (a, b) => a.cantidadTraspasada - b.cantidadTraspasada,
        align: "right",
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => a.estado - b.estado,
        buscar: "estado",
        ellipsis: true,
        render: (estado, record) => {
          let textoEstado = "";
          switch (estado) {
            case 1:
              textoEstado = "Vigente";
              break;
            case 0:
              textoEstado = "Cancelada";
              break;
            default:
              textoEstado = "N/A";
          }
          if (!record.esInsumo) {
            return textoEstado;
          }
          return textoEstado;
        },
      },
    ];

    const columnasVisibles = this.state.desglosarProductos
      ? columns
      : columns.filter(
        (col) => !["clave", "descripcion", "familia"].includes(col.key)
      );

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteTraspasoEntreAlmacenes"
          onFinish={this.consultarReporteTraspasoEntreAlmacenes.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
            proyectos: [],
            estadoTraspaso: 5,
            desglosarProductos: false,
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Traspasos entre Almacenes"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>

                <TabPane tabKey="3" key="3" forceRender tab="Usuarios">
                  <FormItem name="usuarios" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Usuarios"
                    >
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyectos">
                  <FormItem name="proyectos" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Filtrar por Proyecto(s)"
                    >
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    {/* <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoRequisicion"
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por Estado">
                          <Option default value={5}>
                            Todos
                          </Option>
                          <Option value={1}>Pendiente</Option>
                          <Option value={2}>En Proceso</Option>
                          <Option value={3}>Terminada</Option>
                          <Option value={0}>Cancelada</Option>
                        </SelectItem>
                      </FormItem>
                    </Col> */}
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Insumos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        style={{ marginBottom: 0, marginLeft: 20 }}
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            {!this.state.desglosarProductos && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingBottom: 35,
                  marginTop: 10,
                  marginBottom: 10,
                  height: 420,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

                <ResponsiveLine
                  data={this.state.dataGrafico}
                  margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                  // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                  enableSlices="x"
                  useMesh={true}

                  yFormat={(e) => e}

                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: 0,
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}

                  curve="monotoneX"
                  lineWidth={2}

                  // ✅ Menos ruido visual
                  pointSize={5}
                  pointBorderWidth={1}
                  pointColor={{ theme: "background" }}
                  pointBorderColor={{ from: "serieColor" }}

                  // Si quieres aún más limpio, descomenta:
                  // enablePoints={false}

                  colors={["#ff6633", "#FF926E"]}
                  colorBy="index"

                  axisTop={null}
                  axisRight={null}

                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 8,
                    tickRotation: 45,
                    // ✅ muestra menos etiquetas (una de cada 2 o 3)
                    tickValues: (this.state.dataGrafico?.[0]?.data || [])
                      .map(d => d.x)
                      .filter((_, i) => i % 2 === 0),
                  }}

                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 8,
                    format: (v) => v,
                  }}

                  // ✅ Grid más limpio
                  enableGridX={false}

                  legends={[
                    {
                      anchor: "top-right",
                      direction: "column",
                      translateX: 0,
                      translateY: 0,
                      itemWidth: 130,
                      itemHeight: 18,
                      symbolSize: 10,
                      symbolShape: "circle",
                      itemOpacity: 0.85,
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            )}

            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row justify="center">
                <Col span={6} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Insumos Traspasados</p>
                  <h1 style={{ fontSize: 15 }}>
                    {this.state.totalInsumosTraspasados}
                  </h1>
                </Col>
              </Row>
            </div>

            <TableItem
              rowKey="filaId"
              columns={columnasVisibles}
              dataSource={this.state.todasTraspasos}
              size="small"
              pagination={false}

            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteTraspasoEntreAlmacenes);
